import { render, staticRenderFns } from "./SuppliesWrhousngStatus.vue?vue&type=template&id=08849b12&scoped=true&"
import script from "./SuppliesWrhousngStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesWrhousngStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesWrhousngStatus.vue?vue&type=style&index=0&id=08849b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08849b12",
  null
  
)

export default component.exports